import React from "react";
import { Layout, Menu, Button } from "antd";

import "./layout.css";
import { Routes, Route, useNavigate } from "react-router-dom";
import {
  DashboardOutlined,
  UserOutlined,
  SettingOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  ShoppingOutlined,
  ShopOutlined,
  ExpandOutlined,
  BgColorsOutlined,
  LogoutOutlined,
  InfoCircleOutlined,
  SafetyCertificateOutlined,
  DollarCircleOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { accessToken, refreshToken, userData } from "../redux/userDataSlice";
import { callApi } from "../api/apiCaller";
import { routes } from "../api/routes";
import { useState } from "react";
import Loader from "../components/loader/loader";
import { GreenNotify, RedNotify } from "../helper/helper";
import Dashboard from "../pages/dashboard/dashboard";
import Home from "../pages/home/home";
import Users from "../pages/userlist/Users";
import ProductList from "../pages/productList/productList";
import ShopList from "../pages/shops/shops";
import SizeVariants from "../pages/sizeVarient/sizeVarient";
import ColorVariants from "../pages/colorVarient/colorVarient";
import TermsConditions from "../pages/termsConditions/termsConditions";
import PrivacyPolicy from "../pages/privacyPolicy/privacyPolicy";
import Orders from "../pages/orders/orders";
import MonnifyTransactions from "../pages/monnify/monnify";
import PlatformFees from "../pages/platformFees/platformFees";

const { Header, Sider, Content } = Layout;
const LayoutDashboard = () => {
  const [isloading, setIsLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logOut = () => {
    // let getRes = (res) => {
    //   if (res.status === 200) {
    //     GreenNotify(res.message);
    dispatch(userData(null));
    dispatch(accessToken(""));
    dispatch(refreshToken(""));
    //   } else {
    //     RedNotify(res.message);
    //   }
    // };

    // let body = {
    //   device: {
    //     id: localStorage.getItem("deviceId"),
    //     deviceToken: "xyz",
    //   },
    // };

    // callApi("POST", routes.logOut, body, setIsLoading, getRes, (error) => {
    //   console.log("error", error);
    // });
  };
  return (
    <Layout className="admin-layout">
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        className="admin-sider"
        theme="light"
        breakpoint="lg"
      >
        <div className="header-logo">{collapsed ? "Skip" : "Skip The DM"}</div>
        <Menu
          mode="inline"
          defaultSelectedKeys={["1"]}
          items={[
            {
              key: "1",
              icon: <DashboardOutlined />,
              label: "Dashboard",
              onClick: () => navigate("/"),
            },
            {
              key: "2",
              icon: <UserOutlined />,
              label: "Users",
              onClick: () => navigate("/users"),
            },
            {
              key: "3",
              icon: <ShoppingOutlined />,
              label: "Orders",
              onClick: () => navigate("/orders"),
            },
            {
              key: "4",
              icon: <ShoppingOutlined />,
              label: "Product List",
              onClick: () => navigate("/products"),
            },
            {
              key: "5",
              icon: <ShopOutlined />,
              label: "Shops",
              onClick: () => navigate("/shops"),
            },
            {
              key: "6",
              icon: <ExpandOutlined />,
              label: "Size Variant",
              onClick: () => navigate("/size-variant"),
            },
            {
              key: "7",
              icon: <BgColorsOutlined />,
              label: "Color Variant",
              onClick: () => navigate("/color-variant"),
            },
            {
              key: "8",
              icon: <DollarCircleOutlined />,
              label: "Monnify",
              onClick: () => navigate("/monnify"),
            },
            {
              key: "9",
              icon: <DollarOutlined />,
              label: "Platform Fees",
              onClick: () => navigate("/platform-fees"),
            },
            {
              key: "10",
              icon: <InfoCircleOutlined />,
              label: "Terms & Conditions",
              onClick: () => navigate("/terms-conditions"),
            },
            {
              key: "11",
              icon: <SafetyCertificateOutlined />,
              label: "Privacy Policy",
              onClick: () => navigate("/privacy-policy"),
            },
            {
              key: "12",
              icon: <LogoutOutlined />,
              label: "Log Out",
              onClick: () => logOut(),
            },
          ]}
        />
      </Sider>

      <Layout>
        <Header className="admin-header">
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            className="menu-trigger-btn"
          />
          <h1 className="header-title">Skip-The-DM admin panel</h1>
        </Header>

        <Content className="admin-content">
          <Routes>
            <Route path="/" element={<Dashboard />}></Route>
            <Route path="/home" element={<Home />}></Route>
            <Route path="/users" element={<Users />}></Route>
            <Route path="/orders" element={<Orders />}></Route>
            <Route path="/products" element={<ProductList />}></Route>
            <Route path="/shops" element={<ShopList />}></Route>
            <Route path="/size-variant" element={<SizeVariants />}></Route>
            <Route path="/color-variant" element={<ColorVariants />}></Route>
            <Route path="/monnify" element={<MonnifyTransactions />}></Route>
            <Route path="/platform-fees" element={<PlatformFees />}></Route>
            <Route
              path="/terms-conditions"
              element={<TermsConditions />}
            ></Route>
            <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default LayoutDashboard;
